import React, { useEffect, useState } from 'react'
import { Notification, Spinner, useMediaQuery } from '@offerzen/pinata'
import { useRegion } from 'clientHelpers/context/regionContext'
import CandidateStatistics from 'components/CandidateStatistics'
import PropTypes from 'prop-types'
import ListBody from './elements/ListBody'
import ListFooter from './elements/ListFooter'
import ListHeader from './elements/ListHeader'
import styles from './styles'

const RAND_DETAILS = {
  symbol: 'R',
  period: 'month',
  value: 'ZAR',
  label: 'ZAR (South African Rand)',
  region: 'za',
}

const EURO_DETAILS = {
  symbol: '€',
  period: 'year',
  value: 'EUR',
  label: 'EUR (Euro)',
  region: 'eu',
}

const CURRENCIES = [RAND_DETAILS, EURO_DETAILS]

const MAX_DISPLAYED_CARDS = 5

const CandidateList = ({ candidates, totalCandidates, filtersSelected, loading, error, totalCandidatesConstant }) => {
  const [displayedCurrency, setDisplayedCurrency] = useState(EURO_DETAILS) // set Euro as default currency
  const totalDisplayedCandidates = candidates?.length
  const hasCandidates = totalDisplayedCandidates > 0

  const { isTabletOrLarger } = useMediaQuery()
  const { region } = useRegion()

  useEffect(() => {
    if (region === RAND_DETAILS.region.toUpperCase()) {
      setDisplayedCurrency(RAND_DETAILS)
    } else {
      setDisplayedCurrency(EURO_DETAILS)
    }
  }, [region])

  return (
    <div className={`candidate-list-container ${styles.candidateContainer}`}>
      {error ? (
        <Notification theme={'error'} className={styles.errorNotification}>
          {error}
        </Notification>
      ) : (
        <>
          <ListHeader
            totalCandidates={totalCandidates}
            currencies={CURRENCIES}
            setDisplayedCurrency={setDisplayedCurrency}
            displayedCurrency={displayedCurrency}
            filtersSelected={filtersSelected}
          />
          {loading ? (
            <Spinner />
          ) : (
            <>
              <ListBody
                candidates={candidates}
                hasCandidates={hasCandidates}
                displayedCurrency={displayedCurrency}
                filtersSelected={filtersSelected}
              />
              <div className={styles.footerContainer}>
                {hasCandidates && (
                  <ListFooter
                    totalCandidates={totalCandidates}
                    filtersSelected={filtersSelected}
                    hasOverlay={totalDisplayedCandidates > MAX_DISPLAYED_CARDS}
                  />
                )}
              </div>
            </>
          )}
        </>
      )}

      {!isTabletOrLarger && (
        <div className={styles.mobileOnly}>
          <CandidateStatistics totalCandidatesConstant={totalCandidatesConstant} />
        </div>
      )}
    </div>
  )
}

CandidateList.propTypes = {
  candidates: PropTypes.array,
  totalCandidates: PropTypes.number,
  filtersSelected: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
  totalCandidatesConstant: PropTypes.number,
}

export default CandidateList
